import React from 'react';
import dynamic from 'next/dynamic';

import { LANDING_PAGE_META_DATA } from 'journey/findNearMe/utils/constructStoreFinderMetaData.utils';
import { MetaTags } from 'shared/components';

const DynamicFindNearMeJourney = dynamic(() => import('journey/findNearMe'), {
  ssr: false,
});

export async function getStaticProps() {
  return {
    props: {},
    revalidate: 1,
  };
}

export default function FindNearMe() {
  return (
    <>
      <MetaTags {...LANDING_PAGE_META_DATA} />
      <DynamicFindNearMeJourney />
    </>
  );
}
